module.exports = __webpack_public_path__ + "static/img/gaozhongshengwu3.7dee5a5d.jpg";